<script>

    export let onQuit = (e) => { };
    export let beforeQuit = (e) => { };
    export let onHide = (e) => { };
    export let topColour = 'darkblue';
    
    let iH;
</script>
<!--svelte:window bind:innerHeight={iH} on:unload={onQuit} on:beforeunload={beforeQuit} on:hidepage={onHide}/>-->
<div style="height: {iH}px;">
    <!--<header>
        <slot name="header"></slot>
    </header>
    <main>
        <slot name="main"></slot>
    </main>
    <footer>
        <slot name="footer"></slot>
    </footer>-->
    <div id="top" >
        <slot name="top"></slot>
    </div>
    <div class="main">
        <slot name="main" style="{!$$slots.bottom ? 'bottom: 0vmin;' : ''}"></slot>
    </div>
    <div id="bottom">
        <slot name="bottom"></slot>
    </div>
</div >

<style>
    :global(body) {
		background-color: black;
		margin: 0;
		color: white;
		/*overflow: hidden;
		/*width: 100%;
		height: 100%;*/
	}

    .main {
        position: absolute;
        top: 4vmin;
        bottom: 10vmin;
        width: 100%;
    }

    #top > :global(div) {
        position: absolute;
        background-color: darkblue;
        top: 0;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 4vmin;
        padding-left: 5px;
        padding-right: 5px;
    }

    #bottom > :global(div) {
        position: absolute;
        bottom: 0;
        height: 8vmin;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 2px solid white;
    }

    .textgroup {
        display: flex; 
        align-items: center;
    }
</style>